import React from "react";
import ListSubheader from "@material-ui/core/ListSubheader";
import DashboardIcon from "@material-ui/icons/Dashboard";
import ShoppingCartIcon from "@material-ui/icons/ShoppingCart";
import BarChartIcon from "@material-ui/icons/BarChart";
import PersonOutlineIcon from "@material-ui/icons/PersonOutline";
import MenuBookIcon from "@material-ui/icons/MenuBook";
import InfoIcon from "@material-ui/icons/Info";
import PowerSettingsNewIcon from "@material-ui/icons/PowerSettingsNew";
import MenuItem from "../../components/base/MenuItem";
import { useTranslation } from "react-i18next";

export function MainListItems() {
  const { t } = useTranslation();

  const menuItemStyle = {
    position: "relative",
    zIndex: 9999,
  };

  return (
    <div>
      <MenuItem
        text={t("Assigned Tests")}
        icon={<DashboardIcon />}
        to={"/home"}
        style={menuItemStyle}
      />
      <MenuItem
        text={t("All Tests")}
        icon={<ShoppingCartIcon />}
        to={"/app"}
        style={menuItemStyle}
      />
      <ListSubheader inset>Other</ListSubheader>
      <MenuItem
        text={t("Test History")}
        icon={<BarChartIcon />}
        to={"/testhistory"}
        style={menuItemStyle}
      />
      <MenuItem
        text={t("Dictionary")}
        icon={<MenuBookIcon />}
        to={"/dictionary"}
        style={menuItemStyle}
      />
      <MenuItem
        text={t("Test Resources")}
        icon={<PersonOutlineIcon />}
        to={"/resources"}
        style={menuItemStyle}
      />
      <MenuItem
        text={t("Leaderboard")}
        icon={<PersonOutlineIcon />}
        to={"/leaderboard"}
        style={menuItemStyle}
      />
      <MenuItem
        text={t("Report")}
        icon={<PersonOutlineIcon />}
        to={"/report"}
        style={menuItemStyle}
      />
      <MenuItem
        text={t("Global Info")}
        icon={<InfoIcon />}
        to={"/globalinfo"}
        style={menuItemStyle}
      />
      <ListSubheader inset>Account</ListSubheader>
      <MenuItem
        text={t("Edit Account")}
        icon={<PersonOutlineIcon />}
        to={"/editaccount"}
        style={menuItemStyle}
      />
      <MenuItem
        text={t("Logout")}
        icon={<PowerSettingsNewIcon />}
        to={"/app"}
        style={menuItemStyle}
      />
    </div>
  );
}
